var _g, _path, _path2, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageFreeTrialExpired = function SvgImageFreeTrialExpired(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 68"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Image_FreeTrialExpired_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C499",
    fillOpacity: 0.5,
    d: "M53.018 33.667c0-10.53-8.596-19.067-19.2-19.067s-19.2 8.536-19.2 19.067c0 10.53 8.596 19.066 19.2 19.066v2.6c-12.05 0-21.818-9.7-21.818-21.666S21.768 12 33.818 12s21.818 9.7 21.818 21.667c0 11.966-9.768 21.666-21.818 21.666v-2.6c10.604 0 19.2-8.536 19.2-19.066"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Image_FreeTrialExpired_svg__b)",
    stroke: "url(#Image_FreeTrialExpired_svg__c)",
    d: "M33.818 12.5c11.777 0 21.319 9.48 21.319 21.167 0 11.52-9.273 20.895-20.819 21.16v-1.6c10.646-.264 19.2-8.917 19.2-19.56 0-10.81-8.823-19.567-19.7-19.567s-19.7 8.757-19.7 19.567c0 10.643 8.555 19.296 19.2 19.56v1.6c-11.545-.264-20.818-9.64-20.818-21.16C12.5 21.98 22.041 12.5 33.818 12.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Image_FreeTrialExpired_svg__d)",
    stroke: "url(#Image_FreeTrialExpired_svg__e)",
    d: "M38.409 50.77c-9.516 2.519-19.281-3.101-21.815-12.544s3.119-19.143 12.635-21.662 19.282 3.102 21.816 12.545-3.12 19.143-12.636 21.661Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.855,
    height: 1.6,
    x: 30.391,
    y: 9.033,
    fill: "url(#Image_FreeTrialExpired_svg__f)",
    stroke: "url(#Image_FreeTrialExpired_svg__g)",
    rx: 0.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Image_FreeTrialExpired_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C499",
    d: "M32.586 41.408v-2.597h2.852v2.597zm0-4.231V24.482h2.852v12.695z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Image_FreeTrialExpired_svg__b",
    x1: 33.818,
    x2: 33.818,
    y1: 12,
    y2: 55.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Image_FreeTrialExpired_svg__c",
    x1: 33.818,
    x2: 33.818,
    y1: 12,
    y2: 55.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#00C499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Image_FreeTrialExpired_svg__e",
    x1: 20.83,
    x2: 55.772,
    y1: 55.94,
    y2: 11.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#00C499",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Image_FreeTrialExpired_svg__f",
    x1: 33.818,
    x2: 33.818,
    y1: 8.533,
    y2: 12.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#004761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Image_FreeTrialExpired_svg__g",
    x1: 33.818,
    x2: 33.818,
    y1: 7.883,
    y2: 9.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Image_FreeTrialExpired_svg__a",
    width: 67.637,
    height: 67.334,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_10484_59225",
    stdDeviation: 6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Image_FreeTrialExpired_svg__h",
    width: 16.854,
    height: 30.926,
    x: 25.586,
    y: 17.482,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.768254 0 0 0 0 0.601434 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10484_59225"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10484_59225",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Image_FreeTrialExpired_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-46.9091 53.95 -51.6244 -44.2657 49.092 11.567)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#00C499",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00C499"
  })))));
};
export default SvgImageFreeTrialExpired;